
export const UPDATE_MULTIPLE_VALUES_ACTION = "UPDATE_MULTIPLE_VALUES_ACTION";

export const reducer = (state, action) => {
  return {
    ...state,
    ...action.payload,
  };
};
